// extracted by mini-css-extract-plugin
module.exports = {"authoringContainer":"StickyContainer_authoringContainer__Wtvnp"};